// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"ec88a7b8","107":"85aecf09","349":"e394eaa1","598":"0db588a6","703":"f789af4e","787":"366e2403"}[chunkId] + ".chunk.js";
};